import { EntityService } from '../../../service/EntityService';

export class TokenService extends EntityService {

  static entity = 'app/token';

  static uploadCertificate(passwordCer: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload-certificate?passwordCer=${passwordCer}`, data).then(res => res.data);
  }

  static changePass(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/change-pass`, data).then(res => res.data);
  }

  static getPermissionList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/permision`, { params }).then(res => res.data);
  }

  static forms = [
    { value: 1, label: 'Thêm mới' },
    { value: 2, label: 'Gia hạn' },
    { value: 3, label: 'Ngừng sử dụng' }
  ];
  static tokenTypes = [
    { value: 0, label: 'USB' },
    { value: 1, label: 'FILE' },
    { value: 2, label: 'EASYCA' },
    { value: 3, label: 'NCCA' },
    { value: 4, label: 'ICA' }
  ];

}
